import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class CryptographService {

  constructor(private authService: AuthService) { }

  encrypt(data: any): string {
    var rsa = forge.pki.publicKeyFromPem(environment.publicKeyPem);
    var escriptedData = window.btoa(rsa.encrypt(data));
    return escriptedData;
  }

  encryptData(data: any): { encryptedKey: string; encryptedData: string; iv: string; tag: string, email: string | null } {

    // Gera uma chave AES aleatória
    const aesKey = forge.random.getBytesSync(32); // 32 bytes = 256 bits

    // Gera um IV aleatório (96 bits recomendado para GCM)
    const iv = forge.random.getBytesSync(12);

    // Converte os dados para JSON e depois para bytes UTF-8
    const jsonData = JSON.stringify(data);
    const utf8Bytes = forge.util.encodeUtf8(jsonData); // Garante a codificação UTF-8

    // Criptografa os dados com AES-GCM
    const cipher = forge.cipher.createCipher('AES-GCM', aesKey);
    cipher.start({ iv });
    cipher.update(forge.util.createBuffer(utf8Bytes));
    cipher.finish();

    // Dados criptografados e tag GCM
    const encryptedData = cipher.output.bytes();
    const tag = cipher.mode.tag.bytes();

    // Criptografa a chave AES com RSA
    const publicKeyPem = environment.publicKeyPem;
    const rsa = forge.pki.publicKeyFromPem(publicKeyPem);
    const encryptedKey = rsa.encrypt(aesKey);

    const email = this.authService.getEmail();

    return {
      encryptedKey: forge.util.encode64(encryptedKey), // Chave AES criptografada
      encryptedData: forge.util.encode64(encryptedData), // Dados criptografados
      iv: forge.util.encode64(iv), // IV em Base64
      tag: forge.util.encode64(tag), // Tag GCM em Base64
      email: email // Email
    };
  }
}